import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorStateIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 234 209",
	height: 209,
	width: 234,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			strokeLinejoin: "round",
			strokeLinecap: "round",
			strokeWidth: 7.5,
			stroke: "#FF8264",
			d: "M104.353 78L47.3525 135"
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeLinejoin: "round",
			strokeLinecap: "round",
			strokeWidth: 7.5,
			stroke: "#FF8264",
			d: "M47.2368 77.8844L104.353 135"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#BB4D0F",
			d: "M177.832 110.95C177.832 110.95 177.426 89.6556 177.426 72.7305C177.426 72.7305 165.352 74.771 165.352 88.3771C165.352 119.272 161.618 116.004 158.968 122.998C157.08 127.985 157.732 131.727 161.661 134.165H169.069V126.08L177.832 110.95Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C4BACC",
			d: "M191.274 53.745C191.504 47.3921 188.115 42.1334 183.697 42.0028C179.288 41.864 175.518 46.9103 175.296 53.255C175.065 59.6079 178.454 64.8666 182.872 64.9972C187.29 65.136 191.052 60.0978 191.274 53.745Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FF8264",
			d: "M204.284 8.27246C204.284 8.27246 209.272 2.92979 217.595 8.62793C221.93 11.5998 223.411 15.1057 227.975 18.8564V36.1201C227.975 36.1201 224.706 35.095 219.863 29.2529C216.68 25.4007 213.395 21.0324 208.738 23.8008C206.782 24.9607 204.284 28.6182 204.284 28.6182V8.27246Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#688CBA",
			d: "M173.75 195.491C175.821 195.491 177.5 197.17 177.5 199.241C177.5 201.312 175.821 202.991 173.75 202.991H9.75C7.67913 202.991 6.00026 201.312 6 199.241C6 197.17 7.67896 195.491 9.75 195.491H173.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#A7BCD6",
			d: "M222.394 195.491C224.464 195.492 226.144 197.17 226.144 199.241C226.143 201.312 224.464 202.991 222.394 202.991H190.287C188.216 202.991 186.537 201.312 186.537 199.241C186.537 197.17 188.216 195.491 190.287 195.491H222.394Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB6AC",
			d: "M187.88 126.071C182.741 143.725 180.574 159.413 179.93 179.624C179.651 188.497 179.989 192.773 179.905 196.244C179.778 201.62 176.476 203 173.639 203C169.694 203 165.223 200.833 166.51 192.79C168.127 182.638 168.458 175.797 168.458 163.698C168.458 157.559 168.458 138.399 168.458 126.071H187.88Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeLinejoin: "round",
			strokeLinecap: "round",
			strokeMiterlimit: 10,
			strokeWidth: 7.5,
			stroke: "#BB4D0F",
			d: "M165.785 126.071H194.437C194.437 150.024 194.437 170.911 194.437 178.362C194.437 184.949 197.129 187.176 200.998 189.809C204.868 192.442 204.639 199.241 199.407 199.241C193.234 199.241 188.95 199.241 188.95 199.241"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#BB4D0F",
			d: "M190.287 75.5753C202.47 66.7783 203.977 58.2015 203.977 41.6235C203.977 34.5029 206.382 31.9375 209.523 31.9375C212.605 31.9375 213.85 34.8331 213.85 37.7372C213.85 41.1324 213.833 40.8022 213.833 44.2397C213.833 57.431 211.699 64.0435 205.882 75.3552C203.114 80.7485 197.704 90.1212 197.704 103.152C197.704 107.19 197.704 107.8 197.704 111.695L203.444 113.549L199.93 131.735L190.49 128.823L190.287 75.5753Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#BB4D0F",
			d: "M170.848 71.6378C158.664 62.8408 157.157 54.264 157.157 37.686C157.157 30.5654 154.752 28 151.611 28C148.529 28 147.285 30.8956 147.285 33.7997C147.285 37.1949 147.302 36.8647 147.302 40.3022C147.302 53.4935 149.435 60.106 155.252 71.4177C158.02 76.811 163.431 86.1837 163.431 99.2141C163.431 103.253 163.431 103.862 163.431 107.757V115.563L161.204 127.798L170.644 124.885L177.285 73L170.848 71.6378Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#BB4D0F",
			d: "M193.285 39H173.285L175.407 49H191.03L193.285 39Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB6AC",
			d: "M190.673 49C190.673 49 193.107 47.3393 194.762 46.1454C196.416 44.9515 193.99 44 189.697 44C185.218 44 179.485 44.2424 175.285 49H190.673Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeLinejoin: "round",
			strokeLinecap: "round",
			strokeMiterlimit: 10,
			strokeWidth: 7.5,
			stroke: "#FAE053",
			d: "M175.285 69.2842C184.581 76.0237 187.739 93.9987 187.739 110.949"
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeLinecap: "round",
			strokeWidth: 7.5,
			stroke: "#FFB6AC",
			d: "M48.156 54.3917C56.4146 49.9929 65.8425 47.5 75.8525 47.5C108.437 47.5 134.853 73.9152 134.853 106.5C134.853 139.085 108.437 165.5 75.8525 165.5C43.2677 165.5 16.8525 139.085 16.8525 106.5C16.8525 96.6343 19.274 87.3342 23.555 79.1616"
		})
	]
});
export default SvgErrorStateIllustration;
